import Player, { TPlayerProps } from '@/App2/Player'

function App2(dataset: TPlayerProps) {
	return <Player {...dataset} />
}

export default App2
